import { makeStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';

export default function HorStep(props) {

    const classes = useStyles();

    const setStep = () => {
        if (props.id < props.currentstep) {
            props.actions.setHorstep(props.id)
        }
    }

    return (

        <div className={classes.stepContainer}>
            <div className={classes.container}>
                {props.hasPrevious ? <div className={classes.line}></div> : <div className={classes.noLine}></div>}
                {props.isComplete ? <button className={classes.completeCircle} onClick={() => setStep()}>
                <CheckIcon className={classes.checkIcon}></CheckIcon>
                </button> : props.isInProgress ? <div className={classes.inprogressCircle}><div className={classes.whiteText}>{props.id}</div></div> : <div className={classes.incompleteCircle}><div className={classes.blackText}>{props.id}</div></div>}
                {props.hasNext ? <div className={classes.line}></div> : <div className={classes.noLine}></div>}
            </div>

            <div className={classes.stepText}>{props.name}</div>
        </div>
    )
}

const useStyles = makeStyles({
    stepContainer: {
        float: "left",
        width: "25%"
    },
    container: {

    },
    stepText: {
        marginTop: 60,
        textAlign: 'center',
        fontFamily: "Roboto",
        fontSize: 18,
        fontWeight: '300',
        color: 'gray'
    },
    completeCircle: {
        width: 50,
        height: 50,
        borderRadius: 25,
        backgroundColor: '#458B00',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        fontFamily: "Roboto",
        shadowColor: '#000000',
        shadowOffset: { width: 10, height: 10 },
        shadowOpacity: 10,
        elevation: 3,
        color: '#fff',
        outline: "none",
        border: "none",
        cursor: "pointer",
        float: "left"
    },
    whiteText: {
        color: '#fff',
        fontSize: 25,
        textAlign: "center",
        fontFamily: "Roboto",
        paddingTop: "10px"
    },
    blackText: {
        color: '#000',
        fontSize: 25,
        textAlign: "center",
        paddingTop: "10px",
        fontFamily: "Roboto",
    },
    incompleteCircle: {
        width: 50,
        height: 50,
        borderRadius: 25,
        backgroundColor: 'lightgray',
        justifyContent: 'center',
        alignItems: 'center',
        shadowColor: '#000000',
        shadowOffset: { width: 10, height: 10 },
        shadowOpacity: 10,
        elevation: 3,
        color: '#fff',
        float: "left"

    },
    inprogressCircle: {
        width: 50,
        height: 50,
        borderRadius: 25,
        backgroundColor: '#1976d2',
        justifyContent: 'center',
        alignItems: 'center',
        shadowColor: '#000000',
        shadowOffset: { width: 10, height: 10 },
        shadowOpacity: 10,
        elevation: 3,
        color: '#fff',
        float: "left"
    },
    line: {
        float: "left",
        height: 2,
        marginTop: 24,
        backgroundColor: 'lightgray',
        shadowColor: '#000000',
        width: "calc(50% - 25px)"
    },
    noLine: {
        float: "left",
        width: "calc(50% - 25px)",
        height: "2px"
    },
    checkIcon:{
        color:"white",
        height:"35px",
        width:"35px",
        position:"relative",
        top:"3px"
    }

});